'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import ReferenceResolversContext from './ReferenceResolversContext';
export default (Component => {
  const ComponentWithContext = props => /*#__PURE__*/_jsx(ReferenceResolversContext.Consumer, {
    children: context => /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      referenceResolverContext: context
    }))
  });

  return ComponentWithContext;
});